// Import components
import InputRadio from 'components/elements/atoms/HookFormComponents/InputRadio/InputRadio';
import Input from 'components/elements/atoms/HookFormComponents/Input/Input';
import Select from 'components/elements/atoms/HookFormComponents/Select/Select';
import { Checkbox } from '../checkbox/Checkbox';
import { PasswordInput } from 'components/elements/atoms/HookFormComponents/Input/PasswordInput';

// Import types
import type { FormFieldType } from 'types/views/form';

export const renderFormFields = (props: FormFieldType) => {
	switch (props.type) {
		case 'radio':
			return <InputRadio {...props} />;

		case 'select':
			return <Select {...props} />;

		case 'checkbox':
			return <Checkbox {...props} />;

		case 'password':
			return <PasswordInput {...props} />;

		default:
			return <Input {...props} />;
	}
};
